<template>
  <v-form v-model="valid" @submit.prevent="submit" ref="form">
    <v-row>
      <v-col>
        <v-text-field
          hide-details="auto"
          label="* Add a short task description"
          dense
          outlined
          v-model="formData.title"
          :rules="[$formRules.required]"
        >
          <v-icon slot="prepend" color="#eaeaea">
            mdi-checkbox-blank-outline
          </v-icon>
        </v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-select
          label="Assigned"
          hide-details="auto"
          outlined
          dense
          :items="items"
          item-text="name"
          item-value="id"
          v-model="formData.assigned_to"
        ></v-select>
      </v-col>

      <v-col cols="3">
        <v-checkbox
          v-model="formData.urgent"
          hide-details="auto"
          label="Urgent"
          class="pt-0 mt-2"
        ></v-checkbox>
      </v-col>

      <v-col cols="5" align="end">
        <v-btn
          color="secondary"
          class="mr-2"
          depressed
          :disabled="!valid"
          :loading="loading"
          type="submit"
        >
          Save
        </v-btn>

        <v-btn color="secondary" text @click="cancel">Cancel</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TaskEditForm',
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    valid: false,
    loading: false,
    formData: {}
  }),
  computed: {
    items() {
      return [
        { header: 'Clients' },
        ...this.task.task_list.project.clients,
        { header: 'Managers' },
        ...this.task.task_list.project.managers,
        { header: 'Workers' },
        ...this.task.task_list.project.workers
      ]
    }
  },
  methods: {
    ...mapActions('tasks', ['updateTask']),
    setFormDefaults() {
      this.formData = {
        title: this.task.title,
        assigned_to: this.task.assigned_to ? this.task.assigned_to.id : null,
        urgent: this.task.urgent
      }
    },
    submit() {
      this.loading = true
      this.updateTask({
        id: this.task.id,
        task_list_id: this.task.task_list.id,
        ...this.formData
      }).finally(() => {
        this.loading = false

        this.cancel()
      })
    },
    cancel() {
      this.$refs.form.reset()

      this.$nextTick(() => {
        this.setFormDefaults()
      })

      this.$emit('cancel')
    }
  },
  created() {
    this.setFormDefaults()
  }
}
</script>
